import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `TileBody`
};

export function useTileBodyStyles(styleSet: IStyleSet) {
  const { semanticColors, fonts } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          fonts.medium,
          {
            color: semanticColors.bodyText,
            padding: `8px 16px`,
            overflow: `auto`
          }
        ]
      },
      styleSet
    ),
    [semanticColors, fonts, styleSet]
  );
}
